<div class="w-50 d-flex justify-content-start align-items-center flex-nowrap " (click)="onToggleChange()">

  <ng-container *ngIf="checked; else notChecked">
    <i class="material-icons active mr-2">done</i>
    <p class="text-nowrap text-white">{{labelAttivo }}</p>
  </ng-container>

  <ng-template #notChecked>
    <i class="material-icons disabled mr-2"></i>
    <p class="text-nowrap text-white">{{labelDisattivo}}</p>
  </ng-template>
</div>